export enum OnboardingStep {
    SetUp = 1,
    PricePlan = 2,
    CompanyInformation = 3,
    YourContactInformation = 4,
    PaymentAndAccountsSettings = 5,
    ConnectedToPensoPay = 6,
    OnboardingFailed = 7,
}
